module.exports = {"350405001":"凤岗街道","350405002":"虬江街道","350405100":"青州镇","350405101":"夏茂镇","350405102":"高砂镇","350405103":"高桥镇","350405104":"富口镇","350405105":"大洛镇","350405200":"南霞乡","350405201":"南阳乡","350405202":"郑湖乡","350405203":"湖源乡","350405400":"金沙园开发区","350405401":"金古园开发区","350405402":"青山纸业工业区","350405403":"海西物流园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350405.json
// module id = 1297
// module chunks = 0